import React, {
  useCallback, useContext, useState
} from 'react';
import { useNavigate } from 'react-router-dom';

import {
  AssetDistributionOption, ButtonBar, ScreenHeader
} from '../../components';
import { useScrollToTop } from '../../hooks';

import { NewPOAContext } from './new-poa-composer';

export function NewPOARetirementPlans() {
  const { powerOfAttorney, setPowerOfAttorney } = useContext(NewPOAContext);
  const navigate = useNavigate();
  const [ retirementPlans, setRetirementPlans ] = useState(powerOfAttorney.retirement_plan_transactions || false);
  
  useScrollToTop();
  
  const handleCancel = useCallback(() => {
    navigate('/home');
  }, [ navigate ]);

  const handleNext = useCallback(() => {
    setPowerOfAttorney(prev => ({ 
      ...prev, 
      retirement_plan_transactions: retirementPlans
    }));
    navigate('../tax-matters');
  }, [ retirementPlans, setPowerOfAttorney, navigate ]);
  
  return (
    <div className="new-poa-retirement-plans screen-container">
      <ScreenHeader
        title="Retirement Plan Transactions"
        description="Decide whether to grant your agent power over retirement accounts"
      />
      
      <div className="content-section">
        <h3>What Are Retirement Plan Powers?</h3>
        <p>
          Retirement plan powers allow your agent to manage your retirement 
          accounts and pension benefits. This includes:
        </p>
        <ul className="retirement-plans-list">
          <li>401(k) and 403(b) accounts</li>
          <li>Traditional and Roth IRAs</li>
          <li>Pension plans and benefits</li>
          <li>SEP-IRA and SIMPLE IRA accounts</li>
          <li>Profit-sharing plans</li>
          <li>Rollover transactions</li>
          <li>Required minimum distributions</li>
        </ul>

        <h3>What Your Agent Can Do</h3>
        <p>If you grant this power, your agent can:</p>
        <ul className="agent-powers">
          <li>Make contribution and withdrawal decisions</li>
          <li>Change investment allocations</li>
          <li>Roll over retirement accounts</li>
          <li>Take required minimum distributions</li>
          <li>Update beneficiary designations</li>
          <li>Handle retirement plan administration</li>
        </ul>

        <h3>Do You Want to Grant This Power?</h3>
        <div className="asset-distribution-option-container">
          <AssetDistributionOption
            id="retirement-plans-yes"
            label="Yes"
            description="Grant power over retirement accounts"
            value="yes"
          />
          <AssetDistributionOption
            id="retirement-plans-no"
            label="No"
            description="Do not grant power over retirement accounts"
            value="no"
          />
        </div>

        <div className="important-note">
          <h4>Important:</h4>
          <p>
            Retirement account decisions can have significant tax implications and 
            affect your long-term financial security. Some plan administrators may 
            require additional documentation beyond a power of attorney.
          </p>
        </div>
      </div>

      <ButtonBar 
        handlePrimary={handleNext}
        handleSecondary={handleCancel}
        primaryText="Continue"
        secondaryText="Cancel"
      />
    </div>
  );
}
